import yargs from 'yargs';

import environment from '@bmd-studio/genstack-environment';

import { initializeCommand } from '../index';
import { buildServices, execServices } from '../services';

export const command = 'deploy';
export const describe = `Build and start the application services.`;

export const builder = (argv: yargs.Argv): yargs.Argv =>  {
  yargs.option('build', {
    describe: `Flag to force a build without any caching`,
    type: 'boolean',
    default: false,
  }).alias('b', 'build');
  yargs.option('cache', {
    describe: `Flag enable docker caching`,
    type: 'boolean',
    default: true,
  });
  yargs.option('detached', {
    describe: `Flag to run in detached mode`,
    type: 'boolean',
    default: true,
  }).alias('d', 'detached');

  initializeCommand();
  
  return argv;
};

export const handler = async(): Promise<void> => {
  const { build, detached, cache } = yargs.argv;

  if (!cache || build || environment.isProduction()) {
    await execServices('docker-compose', [
      'build', 
      (!cache ? '--no-cache' : ''),
    ]);
  }
  await buildServices();
  await execServices('docker-compose', [
    'up', 
    (detached ? '-d' : ''),
  ]);
};